const STORAGE_KEY = 'weeduc_school_course_groups_v3';

function nowIso() {
    return new Date().toISOString();
}

function createId() {
    return `cg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

function delay(ms = 180) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

function readStore() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return seed();
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : seed();
    } catch (e) {
        return seed();
    }
}

function writeStore(rows) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(rows));
}

function seed() {
    const rows = [
        {
            id: 'cg_seed_onboarding',
            name: 'Pacote Onboarding',
            commercialName: 'Pacote Onboarding',
            url: 'pacote-onboarding',
            description: 'Conjunto inicial de cursos para novos alunos.',
            shortDescription: 'Conjunto inicial de cursos para novos alunos.',
            longDescription: '',
            status: 'active',
            courseIds: [],
            priceMode: 'sum',
            customPrice: 0,
            price: 0,
            discount: 0,
            installment: 1,
            approvalEnabled: false,
            minGrade: 0,
            approved: -1,
            certificateEnabled: false,
            certificate: 0,
            availabilityDeadline: 1,
            dayExpired: 1,
            imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&h=500&fit=crop&q=80',
            dateInsert: nowIso(),
            dateUpdate: nowIso(),
        },
        {
            id: 'cg_seed_avancado',
            name: 'Trilha Avançada',
            commercialName: 'Trilha Avançada',
            url: 'trilha-avancada',
            description: 'Grupo com valor promocional fixo.',
            shortDescription: 'Grupo com valor promocional fixo.',
            longDescription: '',
            status: 'active',
            courseIds: [],
            priceMode: 'custom',
            customPrice: 299.9,
            price: 299.9,
            discount: 0,
            installment: 3,
            approvalEnabled: false,
            minGrade: 0,
            approved: -1,
            certificateEnabled: true,
            certificate: 1,
            availabilityDeadline: 30,
            dayExpired: 30,
            imageUrl: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&h=500&fit=crop&q=80',
            dateInsert: nowIso(),
            dateUpdate: nowIso(),
        },
    ];
    writeStore(rows);
    return rows;
}

function normalize(payload = {}) {
    const courseIds = Array.isArray(payload.courseIds)
        ? payload.courseIds.map((id) => String(id)).filter(Boolean)
        : [];
    const priceMode = payload.priceMode === 'custom' ? 'custom' : 'sum';
    const shortDescription = String(payload.shortDescription || payload.description || '').trim();
    const approvalEnabled = payload.approvalEnabled != null
        ? !!payload.approvalEnabled
        : Number(payload.approved) > 0;
    const minGrade = approvalEnabled
        ? (Number(payload.minGrade ?? payload.approved) || 0)
        : 0;
    const certificateEnabled = payload.certificateEnabled != null
        ? !!payload.certificateEnabled
        : Number(payload.certificate) === 1;
    const availabilityDeadline = Number(payload.availabilityDeadline ?? payload.dayExpired) || 1;
    return {
        name: String(payload.name || '').trim(),
        commercialName: String(payload.commercialName || payload.comercialName || '').trim(),
        url: String(payload.url || '').trim(),
        description: shortDescription,
        shortDescription,
        longDescription: String(payload.longDescription || '').trim(),
        status: payload.status === 'inactive' ? 'inactive' : 'active',
        courseIds,
        priceMode,
        customPrice: priceMode === 'custom' ? Number(payload.customPrice) || 0 : 0,
        price: Number(payload.price) || 0,
        discount: Number(payload.discount) || 0,
        installment: Number(payload.installment) || 1,
        approvalEnabled,
        minGrade,
        approved: approvalEnabled ? minGrade : -1,
        certificateEnabled,
        certificate: certificateEnabled ? 1 : 0,
        availabilityDeadline,
        dayExpired: availabilityDeadline,
        imageUrl: payload.imageUrl || null,
    };
}

function enrich(row) {
    if (!row) return null;
    return {
        ...row,
        coursesCount: (row.courseIds || []).length,
    };
}

export default {
    async list(params = {}) {
        await delay();
        let rows = readStore().map(enrich);
        const search = String(params.search || '').trim().toLowerCase();
        if (search) {
            rows = rows.filter(
                (r) =>
                    r.name.toLowerCase().includes(search)
                    || (r.description || '').toLowerCase().includes(search),
            );
        }
        if (params.status) {
            rows = rows.filter((r) => r.status === params.status);
        }
        return { content: rows, totalElements: rows.length };
    },

    async getById(id) {
        await delay();
        const row = readStore().find((r) => String(r.id) === String(id));
        if (!row) throw new Error('Grupo não encontrado');
        return enrich(row);
    },

    async create(payload) {
        await delay();
        const data = normalize(payload);
        if (!data.name) throw new Error('Nome obrigatório');
        const row = {
            id: createId(),
            ...data,
            dateInsert: nowIso(),
            dateUpdate: nowIso(),
        };
        const rows = readStore();
        rows.unshift(row);
        writeStore(rows);
        return enrich(row);
    },

    async update(id, payload) {
        await delay();
        const rows = readStore();
        const index = rows.findIndex((r) => String(r.id) === String(id));
        if (index < 0) throw new Error('Grupo não encontrado');
        const data = normalize(payload);
        if (!data.name) throw new Error('Nome obrigatório');
        rows[index] = {
            ...rows[index],
            ...data,
            id: rows[index].id,
            dateInsert: rows[index].dateInsert,
            dateUpdate: nowIso(),
        };
        writeStore(rows);
        return enrich(rows[index]);
    },

    async remove(id) {
        await delay();
        const rows = readStore().filter((r) => String(r.id) !== String(id));
        writeStore(rows);
        return { success: true };
    },
};
